// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"33":"8a58e3b7","315":"6532c9a2"}[chunkId] + ".css";
};